"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FocusManager = void 0;
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@floating-ui/react");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _FocusManagerModule = _interopRequireDefault(require("./FocusManager.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const FocusManager = props => {
  const {
    refs,
    context
  } = (0, _react2.useFloating)({
    open: true
  });
  const {
    classNames,
    children,
    initialFocus = -1,
    returnFocus = true,
    modal = true,
    guards = true,
    ...restFloatingFocusManagerProps
  } = props;
  return /*#__PURE__*/React.createElement(_react2.FloatingFocusManager, _extends({
    context: context,
    initialFocus: initialFocus,
    modal: modal,
    guards: guards,
    returnFocus: returnFocus
  }, restFloatingFocusManagerProps), /*#__PURE__*/React.createElement("div", {
    ref: refs.setFloating,
    "data-testid": "FocusManager",
    className: (0, _classify.default)(_FocusManagerModule.default.wrapper, classNames?.wrapper)
  }, children));
};
exports.FocusManager = FocusManager;